module.exports = __webpack_public_path__ + "static/media/icon_extension_xlsx.1152eda5.svg";